import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="page-container">
            <div className="hero about-hero">
                <div className="hero-container">
                    <div className="hero-content centered">
                        <h1>Privacy Policy</h1>
                        <p className="hero-subtitle">
                            Your privacy is important to us. This policy explains how we collect, use, and protect your information.
                        </p>
                    </div>
                </div>
            </div>

            <div className="content-section">
                <div className="container">
                    <div className="content-card">
                        <p><strong>Effective date:</strong> June 29, 2020</p>

                        <p>Innovative Development Associates ("us", "we", or "our") operates the website and the Entuber mobile and Web applications (hereinafter referred to as the "Service").</p>

                        <p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>

                        <p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>

                        <h2>Definitions</h2>

                        <h3>Service</h3>
                        <p>Service means the website and the Entuber mobile applications operated by Innovative Development Associates.</p>

                        <h3>Personal Data</h3>
                        <p>Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</p>

                        <h3>Usage Data</h3>
                        <p>Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p>

                        <h3>Cookies</h3>
                        <p>Cookies are small files stored on your device (computer or mobile device).</p>

                        <h3>Data Controller</h3>
                        <p>Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.</p>
                        <p>For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.</p>

                        <h3>Data Processors (or Service Providers)</h3>
                        <p>Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller.</p>
                        <p>We may use the services of various Service Providers in order to process your data more effectively.</p>

                        <h3>Data Subject (or User)</h3>
                        <p>Data Subject is any living individual who is using our Service and is the subject of Personal Data.</p>

                        <h2>Information Collection and Use</h2>
                        <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>

                        <h3>Types of Data Collected</h3>

                        <h4>Personal Data</h4>
                        <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
                        <ul>
                            <li>Email address</li>
                            <li>First name and last name</li>
                            <li>Cookies and Usage Data</li>
                        </ul>

                        <h4>Usage Data</h4>
                        <p>We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device ("Usage Data").</p>
                        <p>This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
                        <p>When you access the Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.</p>

                        <h4>Tracking Cookies Data</h4>
                        <p>We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.</p>
                        <p>Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags, and scripts to collect and track information and to improve and analyze our Service.</p>
                        <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>

                        <p><strong>Examples of Cookies we use:</strong></p>
                        <ul>
                            <li><strong>Session Cookies:</strong> We use Session Cookies to operate our Service.</li>
                            <li><strong>Preference Cookies:</strong> We use Preference Cookies to remember your preferences and various settings.</li>
                            <li><strong>Security Cookies:</strong> We use Security Cookies for security purposes.</li>
                        </ul>

                        <h2>Use of Data</h2>
                        <p>Innovative Development Associates uses the collected data for various purposes:</p>
                        <ul>
                            <li>To provide and maintain our Service</li>
                            <li>To notify you about changes to our Service</li>
                            <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                            <li>To provide customer support</li>
                            <li>To gather analysis or valuable information so that we can improve our Service</li>
                            <li>To monitor the usage of our Service</li>
                            <li>To detect, prevent and address technical issues</li>
                        </ul>

                        <h2>Legal Basis for Processing Personal Data under GDPR</h2>
                        <p>If you are from the European Economic Area (EEA), Innovative Development Associates, the legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Data we collect and the specific context in which we collect it.</p>
                        <p>Innovative Development Associates may process your Personal Data because:</p>
                        <ul>
                            <li>We need to perform a contract with you</li>
                            <li>You have given us permission to do so</li>
                            <li>The processing is in our legitimate interests and it is not overridden by your rights</li>
                            <li>To comply with the law</li>
                        </ul>

                        <h2>Retention of Data</h2>
                        <p>Innovative Development Associates will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies.</p>

                        <h2>Transfer of Data</h2>
                        <p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</p>
                        <p>If you are located outside the United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to the United States and process it there.</p>

                        <h2>Your Data Protection Rights under GDPR</h2>
                        <p>If you are a resident of the European Economic Area (EEA), you have certain data protection rights:</p>
                        <ul>
                            <li>The right to access, update, or delete the information we have on you</li>
                            <li>The right of rectification</li>
                            <li>The right to object</li>
                            <li>The right of restriction</li>
                            <li>The right to data portability</li>
                            <li>The right to withdraw consent</li>
                        </ul>

                        <h2>Children's Privacy</h2>
                        <p>Our Service does not address anyone under the age of 13 ("Children"). We do not knowingly collect personally identifiable information from anyone under the age of 13.</p>

                        <h2>Changes to This Privacy Policy</h2>
                        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>

                        <h2>Contact Us</h2>
                        <p>If you have any questions about this Privacy Policy, please contact us by email: <strong>admin@entuber.com</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;